<div class="overlay" *ngIf="ShowEmailNotificationContainer || ShowInitializeRequestPickup || ShowTrackHistory || ShowTrackDetails || ShowShipmentsStatusUpdateContainer || ShowDeleteLabelQuestion || ShowForceQuestion;"></div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteLabelQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteLabelQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteLabelQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteLabelQuestion = false;DeleteShippingLabel();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowForceQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowForceQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle" *ngIf="this.ShippingDetails.ForceClose != true;">
      {{ 'ForceShippingCloseQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody" *ngIf="this.ShippingDetails.ForceClose != true;">
      {{ 'ForceShippingCloseQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionTitle" *ngIf="this.ShippingDetails.ForceClose == true;">
        {{ 'UnForceShippingCloseQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody" *ngIf="this.ShippingDetails.ForceClose == true;">
        {{ 'UnForceShippingCloseQuestionDescription' | translate }}
      </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowForceQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowForceQuestion = false;ForceShipmentClose();" *ngIf="this.ShippingDetails.ForceClose != true;">{{ 'ForceShipmentClose' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowForceQuestion = false;ForceShipmentClose();" *ngIf="this.ShippingDetails.ForceClose == true;">{{ 'UnForceShipmentClose' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowInitializeRequestPickup">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowInitializeRequestPickup = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'InitializeRequestPickup' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'InitializeRequestPickupDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowInitializeRequestPickup = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowInitializeRequestPickup = false;RequestPickup();">{{ 'RequestPickup' | translate }}</button>
    </div>
</div>

<div class="ShowTrackHistoryContainer animated fadeInDownBig" *ngIf="this.ShowTrackHistory == true">
    <div class="ShowTrackHistoryContainerCloseContainer">
        <i class="material-icons" (click)="this.ShowTrackHistory = false;">close</i>
    </div>
    <div class="ShowTrackHistoryContainerTitle">
        <span>{{'Tracking' | translate}}: {{this.ShippingDetails.TrackingLabel}}</span>
    </div>
    <div class="ShowTrackHistoryContainerTitle">
        <span>{{'ShippingCompany' | translate}}:</span>
        <img [src]="this.parent.BackendServiceUrl + this.ShippingDetails.ShippingCompany.ImagePath">
    </div>

    <div class="ShowTrackHistoryContainerBody">
        <div *ngFor="let e of this.TrackEvents; let i=index;" class="TrackEventContainer" [ngClass]="{ 'different-day': e.FirstEventOfTheDay}">
            <div class="TrackEventContainerTime">
                <span>{{e.DateTimeUI}}</span>
            </div>
            <div class="TrackEventContainerArrow">
                <div class="TrackEventContainerArrowBody"></div>
                <i *ngIf="e.Status.ID != 14;" class="material-icons">radio_button_checked</i>
                <i *ngIf="e.Status.ID == 14;" class="material-icons" style="color: #32aa3a;">check_circle</i>
            </div>
            <div class="TrackEventContainerContent">
                <span>{{e.Event}}</span>
                <span *ngIf="e.Status.ID == 14;" class="DeliveredStatus">{{e.Status.Name}}</span>
                <span *ngIf="e.Status.ID != 14;" class="TranzitStatus">{{e.Status.Name}}</span>
            </div>
        </div>
    </div>

    <div class="ShowTrackHistoryContainerCommands">
        <button mat-raised-button color="primary" (click)="UpdateShippingDetailsTrackingStatus();">
            <i class="material-icons">check</i>
            <span>{{'AcceptAndSave' | translate}}</span>
        </button>
    </div>
</div>

<div class="ShowTrackHistoryContainer animated fadeInDownBig" *ngIf="this.ShowTrackDetails == true">
    <div class="ShowTrackHistoryContainerCloseContainer">
        <i class="material-icons" (click)="this.ShowTrackDetails = false;">close</i>
    </div>
    <div class="ShowTrackHistoryContainerMainTitle">
        <span>{{'Tracking' | translate}}: {{this.ShippingDetails.TrackingLabel}}</span>
    </div>
    <div class="ShowTrackHistoryContainerMainTitle">
        <span>{{'Weight' | translate}}: {{this.ShippingDetails.TotalWeight}} {{this.ShippingDetails.WeightType.Name}}</span>
    </div>

    <div class="ShowTrackHistoryContainerBody" style="border: none;">
        <p>{{'ShippingServiceType' | translate}}: {{this.ShippingDetails?.ShippingServiceType?.Name}}</p>
        <p>{{'ShippingResponsability' | translate}}: {{this.ShippingDetails.ShippingResponsability?.Name}}</p>
        <p *ngIf="this.ShippingDetails.PriceContainsVAT != true;">{{'Price' | translate}}: {{this.ShippingDetails.Price?.UIUnitPrice}} {{this.ShippingDetails.Price?.Currency?.Name}} ({{'ExcludingVAT' | translate}})</p>
        <p *ngIf="this.ShippingDetails.PriceContainsVAT == true;">{{'Price' | translate}}: {{this.ShippingDetails.Price?.UIVATUnitPrice}} {{this.ShippingDetails.Price?.Currency?.Name}} ({{'WithVAT' | translate}})</p>
        <p>{{'Boxes' | translate}}:</p>
        <p *ngFor="let box of this.ShippingDetails.Boxes; let i=index;">{{i+1}} - ({{box.Weight}}{{this.ShippingDetails.WeightType.Name}}) {{box.Length}}X{{box.Width}}X{{box.Height}}</p>
    
        <button mat-raised-button color="primary" class="DetailsButton" (click)="TrackShippingLabel(this.ShippingDetails.TrackingLabel, this.ShippingDetails.ShippingCompany);">
            <i class="material-icons">near_me</i>
            <span>{{ 'Track' | translate }}</span>
        </button>
        <button mat-raised-button color="primary" class="DetailsButton" (click)="CopyLabelShippingDetails();">
            <i class="material-icons">content_copy</i>
            <span>{{ 'Copy' | translate }}</span>
        </button>

        <button mat-raised-button color="primary" class="DetailsButton" (click)="PrintShippingLabel(this.ShippingDetails.TrackingLabel, this.ShippingDetails.ShippingCompany, this.ShippingDetails?.ID);">
            <i class="material-icons">local_print_shop</i>
            <span>{{ 'PrintDocument' | translate }}</span>
        </button>
    </div>

    <div class="ShowTrackHistoryContainerCommands">
        <button mat-raised-button color="primary" (click)="this.ShowTrackDetails = false;">
            <i class="material-icons">check</i>
            <span>{{'AcceptAndSave' | translate}}</span>
        </button>
    </div>
</div>

<div class="ShipmentsStatusUpdateContainer animated fadeInDownBig" *ngIf="ShowShipmentsStatusUpdateContainer">
    <div class="ShipmentsStatusUpdateContainerCloseContainer" (click)="this.ShowShipmentsStatusUpdateContainer = false;">
        <i class="material-icons">close</i>
    </div>
    <div class="ShipmentsStatusUpdateContainerHeadder">
        {{'ShipmentsStatusUpdateBulk' | translate}}
    </div>
    <div class="ShipmentsStatusUpdateContainerBody">
        <p>{{'ShipmentsStatusUpdateBulkDescription' | translate}}</p>

        <div class="ShippingCompany" [ngClass]="{'SelectedShippingCompany': TrackAllAtOnce == true}" (click)="TrackAllAtOnce = true;">
            <div class="ShippingCompanyIcon">
                <i class="material-icons" *ngIf="TrackAllAtOnce == true;" style="color: #0082e6;">radio_button_on</i>
                <i class="material-icons" *ngIf="TrackAllAtOnce == false;">radio_button_off</i>
            </div>
            <div class="ShippingText">
                {{'TrackAllAtOnce' | translate}}
            </div>
        </div>
        <div class="ShippingCompany" [ngClass]="{'SelectedShippingCompany': TrackAllAtOnce == false}" (click)="TrackAllAtOnce = false;">
            <div class="ShippingCompanyIcon">
                <i class="material-icons" *ngIf="TrackAllAtOnce == false;" style="color: #0082e6;">radio_button_on</i>
                <i class="material-icons" *ngIf="TrackAllAtOnce == true;">radio_button_off</i>
            </div>
            <div class="ShippingText">
                {{'NOTTrackAllAtOnce' | translate}}
            </div>
        </div>
    </div>
    <div class="ShipmentsStatusUpdateContainerCommands">
        <button mat-raised-button color="primary" class="ShipmentsStatusUpdateContainerCommandsButton" (click)="TrackShippingLabelsBulk();">
            <i class="material-icons">near_me</i>
            <span>{{'UpdateTrackings' | translate}}</span>
        </button>
    </div>
</div>

<div class="EmailNotificationContainer animated fadeInDown" *ngIf="ShowEmailNotificationContainer">
    <div class="ShipmentsStatusUpdateContainerCloseContainer" (click)="this.ShowEmailNotificationContainer = false;">
        <i class="material-icons">close</i>
    </div>

    <div class="InfoQuestionTitle">
        {{ 'ContactSupport' | translate }}
      </div>

    <div class="EmailNotificationBody">
        <p class="EmailNotificationBodyTitle">{{ 'SendingEmail' | translate }}:</p>

        <div class="SMTPEmailContainer" *ngFor="let e of this.SMTPEmails" (click)="SelectSMTPEmail(e);">
          <span>{{e.Email}}</span>
          <i class="material-icons" *ngIf="e.IsDefault == true;">radio_button_checked</i>
          <i class="material-icons" *ngIf="e.IsDefault == false;" style="color: #000;">radio_button_off</i>
        </div>

        <p class="EmailNotificationBodyTitle" style="margin-top: 25px;">{{ 'SupportProblem' | translate }}:</p>

        <div class="SMTPEmailContainer" *ngFor="let s of this.SupportContacts" (click)="SelectSupportCategory(s);">
          <span>{{s.Category.Name}}</span>
          <i class="material-icons" *ngIf="s.Category.IsSelected == true;" style="color: #0082e6;">radio_button_checked</i>
          <i class="material-icons" *ngIf="s.Category.IsSelected == false;" style="color: #000;">radio_button_off</i>
        </div>

        <p class="EmailNotificationBodyTitle" style="margin-top: 25px;">{{ 'SendTo' | translate }}:</p>
        <div class="SendToContainer unSelectable">
            <div class="SendToEmailModel" *ngFor="let e of this.CurrentSupportContact.Emails" (click)="e.IsSelected = !e.IsSelected;">
                <span *ngIf="e.IsSelected == true;">{{e.Email}}</span>
                <span *ngIf="e.IsSelected == false;" style="color: #aaa;">{{e.Email}}</span>
                <i class="material-icons" *ngIf="e.IsSelected == true;">check</i>
                <i class="material-icons" *ngIf="e.IsSelected == false;" style="color: red;">close</i>
            </div>
        </div>

        <mat-form-field class="fullWidth EmailSubject" appearance="outline" style="margin-top: 20px;">
            <mat-label>{{ 'Subject' | translate }}</mat-label>
            <input autocomplete="off" [(ngModel)]="this.CurrentSupportContact.Subject" matInput>
        </mat-form-field>
      
        <mat-form-field appearance="outline" class="fullWidth">
            <mat-label>{{ 'YourMessage' | translate }}</mat-label>
            <textarea autocomplete="off" matInput
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="15"
                      cdkAutosizeMaxRows="15"
                      [(ngModel)]="this.CurrentSupportContact.Body"></textarea>
        </mat-form-field>
    </div>

    <div class="EmailNotificationCommands" style="margin-top: 25px;">
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="EmailNotificationButton" (click)="this.ShowEmailNotificationContainer = false;">
            <i class="material-icons">close</i>
            {{ 'Cancel' | translate }}
          </button>
        <button [disabled]="this.parent.loading" mat-raised-button class="EmailNotificationButton" (click)="SendContactSupportEmail();">
          <i class="material-icons">email</i>
          {{ 'SendEmailNotification' | translate }}
        </button>
      </div>
</div>

<div class="ShippingMainContent">
      <div class="HalfContentTitle">
          <p>{{'Shipments' | translate}}</p>

          <div class="TitleButton noselect" (click)="NewLabel();">
            <i class="material-icons" style="margin-right: 10px;">add</i>
            <span class="DottedRow">{{'NewShipment' | translate}}</span>
          </div>

          <div class="TitleButton noselect" (click)="PrepareShipmentsStatusUpdate();">
            <i class="material-icons" style="margin-right: 10px;">play_circle_outline</i>
            <span class="DottedRow">{{'UpdateTrackingStatus' | translate}}</span>
          </div>
      </div>

      <div class="FilterHeadder">
        <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter; InitializeCompanies();">
            <i class="material-icons">filter_alt</i>
            <span>{{'Filter' | translate}}</span>
        </div>

        <div class="FilterButton noselect" (click)="GetShipmentsFiltered();">
            <i class="material-icons" style="margin-right: 10px;">check</i>
            <span>{{'ViewShipments' | translate}}</span>
        </div>

        <div class="FilterButton noselect" (click)="SwitchDirection();" [ngClass]="{'ExportColor': this.Filter?.ShippingDirection?.ID == 1, 'ImportColor' : this.Filter?.ShippingDirection?.ID == -1 }">
            <i class="material-icons" style="margin-right: 10px;" *ngIf="this.Filter?.ShippingDirection?.ID == 1;" [ngClass]="{'ExportColor': this.Filter?.ShippingDirection?.ID == 1, 'ImportColor' : this.Filter?.ShippingDirection?.ID == -1 }">flight_takeoff</i>
            <i class="material-icons" style="margin-right: 10px;" *ngIf="this.Filter?.ShippingDirection?.ID == -1;" [ngClass]="{'ExportColor': this.Filter?.ShippingDirection?.ID == 1, 'ImportColor' : this.Filter?.ShippingDirection?.ID == -1 }">flight_land</i>
            <span>{{this.Filter?.ShippingDirection?.Name}}</span>
            <i class="material-icons" style="margin-right: 10px;" *ngIf="this.Filter?.ShippingDirection?.ID == 1;" [ngClass]="{'ExportColor': this.Filter?.ShippingDirection?.ID == 1, 'ImportColor' : this.Filter?.ShippingDirection?.ID == -1 }">keyboard_double_arrow_right</i>
            <i class="material-icons" style="margin-right: 10px;" *ngIf="this.Filter?.ShippingDirection?.ID == -1;" [ngClass]="{'ExportColor': this.Filter?.ShippingDirection?.ID == 1, 'ImportColor' : this.Filter?.ShippingDirection?.ID == -1 }">keyboard_double_arrow_left</i>
        </div>

        <div class="ActiveFilters">
            <div class="ActiveFilter" *ngFor="let a of activeFilters" (click)="RemoveActiveFilter(a.ID, a.Type);">
                <i class="material-icons">close</i>
                <span>{{a.Name}}</span>
            </div>
        </div>

        <div class="PagerContainer">
            <div class="PagerButton" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                <i class="material-icons">chevron_right</i>
            </div>
            <div class="PagerButton" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex + 1; GetShipmentsFiltered();">
                <i class="material-icons">chevron_right</i>
            </div>
            <div class="PagerTextContainer">
                <input class="PagerText" type="text" autocomplete="off" [(ngModel)]="this.Filter.Pager.PageSize" (change)="GetShipmentsFiltered();">
            </div>
            <div class="PagerButton" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex - 1; GetShipmentsFiltered();">
                <i class="material-icons">chevron_left</i>
            </div>
            <div class="PagerButton" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                <i class="material-icons">chevron_left</i>
            </div>
            <div class="PagerDescription">
                {{this.Shipments?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'Shipments' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})
            </div>
        </div>

        <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
            <div class="FilterCloseContainer" (click)="this.showFilter = false;">
                <i class="material-icons">close</i>
            </div>
    
            <div class="FilterContainerBody">
                <div class="PopUpBodyRow">
                    <div class="PopUpBodyTwoThirdsContainer">
                        <mat-form-field class="BrandSelectContainer" appearance="outline">
                            <mat-label>{{'ChoosePartner' | translate}}*</mat-label>
                            <input class="BrandSelect"
                                   type="text"
                                   placeholder="{{'ChoosePartner' | translate}}"
                                   matInput
                                   [matAutocomplete]="auto1"
                                   [(ngModel)]="this.FilterPartnerSearchTerm"
                                   (ngModelChange)="this.partnerSearchTermUpdate.next($event)"
                                   (click)="InitializePartners();">
                            <i class="material-icons BrandSelectCloseIcon" *ngIf="this.Filter.Partner?.Name?.length > 0;" (click)="ClearPartnerBrand();">close</i>
                            <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Filter.Partner?.Name?.length > 0) != true;">search</i>
                            <mat-autocomplete #auto1="matAutocomplete">
                              <mat-option *ngFor="let p of Partners" [value]="p" (click)="this.Filter.Partner = p; this.FilterPartnerSearchTerm = p.Name; AddActiveFilter(p.Name, 'Partner');">
                                {{p.Name}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                    </div>
                    <div class="PopUpBodyOneThirddContainer">
                        <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                              <mat-label>{{ 'ShippingCompany' | translate }}</mat-label>
                              <mat-select name="ShippingCompany" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Filter.ShippingCompany">
                                <mat-option *ngFor="let s of this.ShippingCompanies" [value]="s" (click)="AddActiveFilter(s.Name, 'ShippingCompany');">
                                    <span class="MatOptionSpan">{{s.Name}}</span>
                                    <img class="MatOptionImage" [src]="this.parent.BackendServiceUrl + s.ImagePath">
                                </mat-option>
                              </mat-select>
                          </mat-form-field>
                    </div>
                </div>

                <div class="PopUpBodyRow">
                    <div class="PopUpBodyTwoThirdsContainer">
                        <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                            <mat-label>{{ 'Company' | translate }}</mat-label>
                            <mat-select name="Company" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Filter.Company">
                              <mat-option *ngFor="let c of this.Companies" [value]="c" (click)="AddActiveFilter(c.Name, 'Company');">
                                {{c.Name}}
                              </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="PopUpBodyOneThirddContainer">
                        <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                            <mat-label>{{ 'ShippingServiceType' | translate }}</mat-label>
                            <mat-select name="ShippingServiceType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Filter.ShippingServiceType">
                              <mat-option *ngFor="let t of this.ShippingServiceTypes" [value]="t" (click)="AddActiveFilter(t.Name, 'ShippingServiceType');">
                                {{t.Name}}
                              </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="PopUpBodyRow">
                    <div class="PopUpBodyOneThirddContainer">
                        <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                            <mat-label>{{ 'ShippingDirection' | translate }}</mat-label>
                            <mat-select name="ShippingDirection" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Filter.ShippingDirection">
                              <mat-option *ngFor="let c of this.Directions" [value]="c">
                                {{c.Name}}
                              </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="PopUpBodyTwoThirdsContainer">
                        <mat-form-field class="BrandSelectContainer" appearance="outline">
                            <mat-label>{{'TrackingStatus' | translate}}*</mat-label>
                            <input class="BrandSelect"
                                   type="text"
                                   placeholder="{{'TrackingStatus' | translate}}"
                                   matInput
                                   [matAutocomplete]="auto2"
                                   [(ngModel)]="this.FilterTrackingStatus"
                                   (ngModelChange)="this.trackingStatusSearchTermUpdate.next($event)"
                                   (click)="InitializeTrackingStatus();">
                            <i class="material-icons BrandSelectCloseIcon" *ngIf="this.Filter.TrackingStatus?.Name?.length > 0;" (click)="ClearTrackingStatus();">close</i>
                            <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Filter.TrackingStatus?.Name?.length > 0) != true;">search</i>
                            <mat-autocomplete #auto2="matAutocomplete">
                              <mat-option *ngFor="let t of TrackingStatuses" [value]="t" (click)="this.Filter.TrackingStatus = t; this.FilterTrackingStatus = t.Name; AddActiveFilter(t.Name, 'TrackingStatus');">
                                {{t.Name}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                    </div>
                </div>

                <div class="PopUpBodyRow">
                    <div class="PopUpBodyOneThirddContainer">
                        <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                            <mat-label>{{ 'ShippingCostStatus' | translate }}</mat-label>
                            <mat-select name="ShippingCostStatus" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Filter.CostStatus">
                              <mat-option *ngFor="let s of this.ShippingCostStatuses" [value]="s">
                                {{s.Name}}
                              </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="PopUpBodyTwoThirdsContainer">
                      
                    </div>
                </div>

                <div class="PopUpBodyRow">
                    <div class="PopUpBodyTwoThirdsContainer">
                        <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
                            <mat-label>{{ 'TrackingLabel' | translate }}</mat-label>
                            <input matInput placeholder="{{ 'TrackingLabel' | translate }}" autocomplete="off" [(ngModel)]="Filter.SearchTerm" (change)="AddActiveFilter(Filter.SearchTerm, 'SearchTerm');">
                          </mat-form-field>
                    </div>
                    <div class="PopUpBodyOneThirddContainer">
                        
                    </div>
                </div>
            </div>
            
            <div class="FilterCommands">
                <button mat-raised-button class="FilterButtonAction" color="primary" (click)="GetShipmentsFiltered();">
                    <i class="material-icons">check</i>
                    <span>{{ 'Filter' | translate }}</span>
                </button>
            </div>
        </div>
      </div>

      <div class="TableMasterContainer">
        <div class="ShippingTableRow ShippingTableHeadder">
            <div class="ShippingTableCol">
                <mat-checkbox class="tableColCheckBox" [(ngModel)]="AllSelected" (change)="SelectAll();"></mat-checkbox>
            </div>
            <div class="ShippingTableCol">#</div>
            <div class="ShippingTableCol DottedRow" style="width: 10%;">{{'EventRegister' | translate}}</div>
            <div class="ShippingTableCol DottedRow textLeft" style="width: 15%;">{{'From' | translate}}</div>
            <div class="ShippingTableCol DottedRow textLeft" style="width: 15%;">{{'To' | translate}}</div>
            <div class="ShippingTableCol DottedRow" style="width: 10%;">{{'Tracking' | translate}}</div>
            <div class="ShippingTableCol DottedRow" style="width: 10%;">{{'ShippingCompany' | translate}}</div>
            <div class="ShippingTableCol DottedRow" style="width: 5%;">{{'ShippingServiceType' | translate}}</div>
            <div class="ShippingTableCol DottedRow textRight" style="width: 10%;">{{'ShippingCost' | translate}}</div>
            <div class="ShippingTableCol DottedRow" style="width: 10%;">{{'Status' | translate}}</div>
            <div class="ShippingTableCol DottedRow" style="width: 10%;">{{'Actions' | translate}}</div>
        </div>

        <div class="ShippingTableRow" *ngFor="let s of this.Shipments; let i=index;">
            <div class="ShippingTableRowHead" (click)="ShowShipmentDetails(s);">
                <div class="ShippingTableCol" style="padding-top: 7px;">
                    <mat-checkbox class="tableColCheckBox" [(ngModel)]="s.IsSelected" (change)="CheckIfAnyChecked();"></mat-checkbox>
                </div>
                <div class="ShippingTableCol"><span>{{i+1}}</span></div>
                <div class="ShippingTableCol" style="width: 10%;">
                    <span>{{s.EventRegisterUI}}</span>
                    <span *ngIf="s.CostStatus?.ID == 2;" class="CostStatusDot" matTooltip="{{s.CostStatus?.Name}}" matTooltipClass='neutral-tool-tip-management'></span>
                    <span style="background: gold;" *ngIf="s.CostStatus?.ID == 1;" class="CostStatusDot" matTooltip="{{s.CostStatus?.Name}}" matTooltipClass='neutral-tool-tip-management'></span>
                    <span style="background: #fd4f57" *ngIf="s.CostStatus?.ID == -1;" class="CostStatusDot" matTooltip="{{s.CostStatus?.Name}}" matTooltipClass='neutral-tool-tip-management'></span>
                </div>
                <div class="ShippingTableCol  textLeft" style="width: 15%;"><span>{{s.Sender?.ContactCompany}}</span></div>
                <div class="ShippingTableCol  textLeft" style="width: 15%;"><span>{{s.Receiver?.ContactCompany}}</span></div>
                <div class="ShippingTableCol" style="width: 10%;">
                    <span style="margin: 0;">{{s.TrackingLabel}}</span>
                    <span class="ShippingTableColDescription">{{s.Boxes.length}} {{'Boxes' | translate}} ({{s.TotalWeight}} {{s.WeightType.Name}})</span>
                </div>
                <div class="ShippingTableCol" style="width: 10%;">
                    <img [src]="this.parent.BackendServiceUrl + s.ShippingCompany.ImagePath">
                    <i class="material-icons shippingServiceIcon" style="color: #0082e6;" *ngIf="s.ShippingServiceType?.ID == -1;">local_shipping</i>
                    <i class="material-icons shippingServiceIcon" style="color: #32aa3a;" *ngIf="s.ShippingServiceType?.ID == 1;">flight_takeoff</i>
                </div>
                <div class="ShippingTableCol" style="width: 5%;">
                    <span style="margin: 0;">{{s.ShippingServiceType?.Name}}</span>
                    <span class="ShippingTableColDescription">({{s.ShippingDirection?.Name}})</span>
                    <i class="material-icons shippingDirectionIcon" style="color: #32aa3a;" *ngIf="s.ShippingDirection?.ID == 1;">north_east</i>
                    <i class="material-icons shippingDirectionIcon" style="color: #0082e6;" *ngIf="s.ShippingDirection?.ID == -1;">south_east</i>
                </div>
                <div class="ShippingTableCol  textRight" style="width: 10%;">
                    <span style="margin: 0;" *ngIf="s.PriceContainsVAT != true;">{{s.Price?.UIUnitPrice}} {{s.Price?.Currency?.Name}}</span>
                    <span style="margin: 0;" *ngIf="s.PriceContainsVAT == true;">{{s.Price?.UIVATUnitPrice}} {{s.Price?.Currency?.Name}}</span>
                    <span class="ShippingTableColDescription" *ngIf="s.PriceContainsVAT != true && s.Price != null;">({{'ExcludingVAT' | translate}})</span>
                    <span class="ShippingTableColDescription" *ngIf="s.PriceContainsVAT == true && s.Price != null;">({{'WithVAT' | translate}})</span>
                </div>
                <div class="ShippingTableCol" style="width: 10%;">
                    <p *ngIf="s.Status?.ID != null;" class="StatusSpan" [ngClass]="{'White': s.Status?.Color?.ID == 0, 'Black': s.Status?.Color?.ID == 1, 'Blue': s.Status?.Color?.ID == 2, 'LightBlue': s.Status?.Color?.ID == 3, 'DarkBlue': s.Status?.Color?.ID == 4
                    , 'Red': s.Status?.Color?.ID == 5, 'LightRed': s.Status?.Color?.ID == 6, 'DarkRed': s.Status?.Color?.ID == 7, 'Green': s.Status?.Color?.ID == 8
                    , 'LightGreen': s.Status?.Color?.ID == 9, 'DarkGreen': s.Status?.Color?.ID == 10
                    , 'Yellow': s.Status?.Color?.ID == 11, 'Orange': s.Status?.Color?.ID == 12
                    , 'Purple': s.Status?.Color?.ID == 13, 'WhiteText': s.Status?.Color?.WhiteText == true}"
                    (dblclick)="TrackShippingLabel(s);">
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 0">question_mark</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 11">question_mark</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 3 && s.ShippingServiceType?.ID == 1;">flight</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 3 && s.ShippingServiceType?.ID == -1;">local_shipping</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 8">check</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 9">delivery_dining</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 2">how_to_reg</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 13">person_off</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 5 || s.Status?.Color?.ID == 6 || s.Status?.Color?.ID == 7 || s.Status?.Color?.ID == 12">warning_amber</i>
                    <span>{{s.Status?.Name}}</span>
                    </p>
    
                    <p *ngIf="s.ForceClose == true;" class="ForceStatusSign" matTooltip="{{ 'ForcedShipment' | translate }}" matTooltipClass='neutral-tool-tip-management'>
                        <i class="material-icons">warning_amber</i>
                    </p>
                </div>
                <div class="ShippingTableCol" style="width: 10%;">
                    
                </div>
            </div>
            <div class="ShippingTableRowBody" *ngIf="s.ShowDetails == true" [ngClass]="{'open': s.ShowDetails}">
                <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.loadingFromGrid == true;"></mat-spinner>

                <div *ngIf="this.GridShippingDetails != null;">
                    <div class="ShippingTableCol DottedRow" style="width: 15%;">
                        <button class="TitleButton ShippingActionButton noselect" (click)="PrintShippingLabel(s.TrackingLabel, s.ShippingCompany, s.ShippingDetailsID);">
                            <i class="material-icons">local_print_shop</i>
                            <span class="DottedRow">{{ 'PrintDocument' | translate }}</span>
                         </button>
                         <button class="TitleButton ShippingActionButton noselect" (click)="CopyLabel(s);">
                            <i class="material-icons">content_copy</i>
                            <span class="DottedRow">{{ 'Copy' | translate }}</span>
                         </button>
                         <button class="TitleButton ShippingActionButton noselect" *ngIf="s.AccountingDocumentID?.length > 0;" (click)="this.parent.GoToDocumentPage(s.AccountingDocumentID, s.ShippingDirection?.ID, s.CompanyID);">
                            <i class="material-icons">linear_scale</i>
                            <span class="DottedRow">{{s.AccountingNumberDisplayValue}}</span>
                         </button>
                    </div>
                    <div class="ShippingTableCol DottedRow textLeft" style="width: 15%;">
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.ContactPerson}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.VATNumber}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.Country.Name}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.State}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.City}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.AddressLine}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.ZipCode}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.Phone}}</div>
                        </div>

                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{'Boxes' | translate}}:</div>
                        </div>
                        <div class="ShippingTableColParagraph" *ngFor="let box of this.GridShippingDetails.Boxes; let y=index;">
                            <div class="ShippingTableColParagraphValue">
                                {{y + 1}} - ({{box.Weight}}{{this.GridShippingDetails?.WeightType?.Name}}) {{box.Length}}X{{box.Width}}X{{box.Height}}
                            </div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{'Total' | translate}}: {{this.GridShippingDetails.TotalWeight}} {{this.GridShippingDetails?.WeightType?.Name}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">
                                <i class="material-icons" style="color: #0082e6;" *ngIf="s.ShippingServiceType?.ID == -1;">local_shipping</i>
                                <i class="material-icons" style="color: #32aa3a;" *ngIf="s.ShippingServiceType?.ID == 1;">flight_takeoff</i>
                            </div>
                        </div>
                    </div>
                    <div class="ShippingTableCol DottedRow textLeft" style="width: 15%;">
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.ContactPerson}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.VATNumber}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.Country.Name}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.State}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.City}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.AddressLine}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.ZipCode}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.Phone}}</div>
                        </div>

                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{'ShippingCost' | translate}}:</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"><span>{{'Aquisition' | translate}}:</span> <span>{{GridShippingDetails?.Statistics?.Cost?.BuyPrice?.UIUnitPrice}} {{GridShippingDetails?.Statistics?.Cost?.BuyPrice?.Currency?.Name}}</span></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"><span>{{'Sale' | translate}}:</span> <span>{{GridShippingDetails?.Statistics?.Cost?.SellPrice?.UIUnitPrice}} {{GridShippingDetails?.Statistics?.Cost?.SellPrice?.Currency?.Name}}</span></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"><span>{{'Profit' | translate}}:</span> <span [ngClass]="{'Profitable': GridShippingDetails?.Statistics?.Cost?.Status?.ID == 2, 'Neutral': GridShippingDetails?.Statistics?.Cost?.Status?.ID == 1, 'Loss': GridShippingDetails?.Statistics?.Cost?.Status?.ID == -1}"><span *ngIf="GridShippingDetails?.Statistics?.Cost?.Status?.ID == 2">+</span>{{GridShippingDetails?.Statistics?.Cost?.Profit?.UIUnitPrice}} {{GridShippingDetails?.Statistics?.Cost?.Profit?.Currency?.Name}}</span></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"><span>{{'Status' | translate}}:</span> <span [ngClass]="{'Profitable': GridShippingDetails?.Statistics?.Cost?.Status?.ID == 2, 'Neutral': GridShippingDetails?.Statistics?.Cost?.Status?.ID == 1, 'Loss': GridShippingDetails?.Statistics?.Cost?.Status?.ID == -1}">{{GridShippingDetails?.Statistics?.Cost?.Status?.Name}}</span></div>
                        </div>
                    </div>
                    <div class="ShippingTableCol DottedRow textLeft" style="width: 35%;padding-left: 2.5%; padding-right: 2.5%;">
                        
                        <div class="ShippingTableColHalfButton" (click)="SelectShippingLog();" [ngClass]="{'SelectedShippingTableColHalfButton': this.ShowShippingLog == true}">
                            <i class="material-icons">check</i>
                            <span>{{'ShippingLog' | translate}}</span>
                        </div>
                        <div class="ShippingTableColHalfButton" (click)="SelectTrackingLog(s);" [ngClass]="{'SelectedShippingTableColHalfButton': this.ShowTrackingLog == true}">
                            <i class="material-icons">check</i>
                            <span>{{'TrackHistory' | translate}}</span>
                        </div>

                        <mat-spinner class="smallSpinnerTrackEvents" [diameter]="30" *ngIf="this.trackEventsLoading == true;"></mat-spinner>

                        <div class="ShippingTableColLogResultsContainer" *ngIf="this.ShowTrackingLog == true && this.TrackEvents?.length > 0;">
                            <p class="TrackEventP" *ngFor="let e of this.TrackEvents; let x=index;" [ngClass]="{'White': e.Status?.Color?.ID == 0, 'Black': e.Status?.Color?.ID == 1, 'Blue': e.Status?.Color?.ID == 2, 'LightBlue': e.Status?.Color?.ID == 3, 'DarkBlue': e.Status?.Color?.ID == 4
                            , 'Red': e.Status?.Color?.ID == 5, 'LightRed': e.Status?.Color?.ID == 6, 'DarkRed': e.Status?.Color?.ID == 7, 'Green': e.Status?.Color?.ID == 8
                            , 'LightGreen': e.Status?.Color?.ID == 9, 'DarkGreen': e.Status?.Color?.ID == 10
                            , 'Yellow': e.Status?.Color?.ID == 11, 'Orange': e.Status?.Color?.ID == 12
                            , 'Purple': e.Status?.Color?.ID == 13, 'WhiteText': e.Status?.Color?.WhiteText == true}">
                               <span class="TrackEventPIndex">{{x + 1}}</span>
                               <span class="TrackEventPDate">{{e.DateTimeUI}}</span>
                               <span class="TrackEventPName">{{e.Status?.Name}}</span>
                            </p>
                        </div>
                        <div class="ShippingTableColLogResultsContainer" *ngIf="this.ShowShippingLog == true && this.GridShippingDetails.ShippingLog?.length > 0;">
                            <p *ngFor="let log of this.GridShippingDetails.ShippingLog; let x=index;" class="TrackEventP">
                                <span class="TrackEventPIndex">{{x + 1}}</span>
                                <span class="TrackEventPDate">{{log.EventRegisterUI}}</span>
                                <span class="TrackEventPName">{{log.EventType?.Name}}</span>
                                <span class="TrackEventPIndex" *ngIf="log.AssociatedUser?.Id?.length > 0;"></span>
                                <span class="TrackEventPDate" *ngIf="log.AssociatedUser?.Id?.length > 0;"></span>
                                <span class="TrackEventPName" *ngIf="log.AssociatedUser?.Id?.length > 0;">{{log.AssociatedUser?.Email}}</span>
                            </p>
                        </div>

                    </div>
                    <div class="ShippingTableCol DottedRow" style="width: 20%;">
                     <button class="TitleButton ShippingActionButton noselect" (click)="GetShippingDetails(s.ShippingDetailsID, s.ShippingDirection.ID);">
                        <i class="material-icons">image_search</i>
                        <span class="DottedRow">{{ 'Details' | translate }}</span>
                     </button>
                     <button class="TitleButton ShippingActionButton noselect" (click)="TrackShippingLabel(s);">
                        <i class="material-icons">near_me</i>
                        <span class="DottedRow">{{ 'Track' | translate }}</span>
                     </button>
                     <button class="TitleButton ShippingActionButton noselect" *ngIf="s.ShippingDirection.ID != 1 && s.Status?.ID < 0;" (click)="GetShippingDetailsForPickup(s.ShippingDetailsID, s.ShippingDirection.ID); InitializeRequestPickup(s);">
                        <i class="material-icons">group_add</i>
                        <span class="DottedRow">{{ 'RequestPickup' | translate }}</span>
                     </button>
                     <button class="TitleButton ShippingActionButton noselect" (click)="GetShippingCompanySupportEmailData(s); GetAttachments(s.TrackingLabel, s.ShippingCompany);">
                        <i class="material-icons">computer</i>
                        <span class="DottedRow">{{ 'ContactSupport' | translate }}</span>
                     </button>
                    
                     <button class="TitleButton ShippingActionButton noselect" (click)="GetShippingDetailsForDeleteRequest(s.ShippingDetailsID, s.ShippingDirection.ID);">
                        <i class="material-icons">cancel</i>
                        <span class="DottedRow">{{ 'RequestCancellation' | translate }}</span>
                     </button>
                     <button class="TitleButton ShippingActionButton noselect" (click)="OpenForceQuestion(s);">
                        <i class="material-icons">autorenew</i>
                        <span class="DottedRow" *ngIf="s.ForceClose != true;">{{ 'ForceShipmentClose' | translate }}</span>
                        <span class="DottedRow" *ngIf="s.ForceClose == true;">{{ 'UnForceShipmentClose' | translate }}</span>
                     </button>
                    </div>
              </div>
            </div>
        </div>
      </div>
</div>